export enum groupTypes {
  UNI = 'uni',
  INSTITUTIONAL = 'institutional',
  MUNICIPAL = 'municipal',
  CROSS_INSTITUTIONAL = 'cross_institutional',
}
